// export const ASSET_PATH = "/wp-content/themes/agog/static/xr-assets/";
export const ASSET_PATH = '/wp-content/themes/agog/static/xr-assets/';
